// extracted by mini-css-extract-plugin
export default {"recommendations":"Mr","retake_quiz":"Nr","products":"Or","unsure":"Pr","icons":"Qr","icon":"Rr"};
    if(module.hot) {
      // 1715632474856
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  